import { Card } from '@mint-lib/tw-components';

import { FileIcon } from '../FileIcon/FileIcon.jsx';
import { FolderNameInput } from './FolderNameInput.jsx';

type Props = {
  initialValue?: string;
  onCommit: (name: string) => boolean;
  onCancel: () => void;
  validateName: (name: string) => boolean;
};

const FolderDraft = ({
  initialValue,
  onCommit,
  onCancel,
  validateName,
}: Props) => {
  return (
    <Card
      variant={'outlined'}
      className="w-full"
      contentClassName="flex flex-row gap-2 items-center justify-start p-2"
    >
      <FileIcon type="folder" />
      <div className="w-full">
        <FolderNameInput
          initialValue={initialValue}
          onCommit={onCommit}
          onCancel={onCancel}
          validateName={validateName}
        />
      </div>
    </Card>
  );
};

export { FolderDraft };
